//@flow
import React, {forwardRef} from 'react';
import {useCreateObjectUrl} from '../../utils/react';

type VideoTagProps = {
  className?: string,
  style?: any,
  width?: number,
  height?: number,
  autoPlay?: boolean,
  controls?: boolean,
  loop?: boolean,
  muted?: boolean,
  poster?: string,

  onClick?: () => void,
  onError?: () => void,
  onLoad?: () => void,
};

type Props = {
  src: string | Blob | File,
} & VideoTagProps;

function VideoRenderer(props: Props, ref: any) {
  const {src, ...rest} = props;

  const isBlob = typeof src !== 'string';

  const {objectURL} = useCreateObjectUrl(typeof src !== 'string' ? src : null);

  if (isBlob && !objectURL) return null;

  const source = isBlob ? objectURL : src;

  //$FlowFixMe
  return <video src={source} {...rest} ref={ref} />;
}

export default forwardRef<Props, typeof VideoRenderer>(VideoRenderer);
